import { useEditorState } from 'common/Prose/EditorProvider/hooks/useEditorState'
import { useEditorView } from 'common/Prose/EditorProvider/hooks/useEditorView'
import { isEqual } from 'lodash'
import React, { useEffect, useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import {
  ContextualBlockActionsPluginKey,
  ContextualBlockActionsPluginState,
  registeredActions,
} from './ContextualBlockActions'
import { registerSortVoteList } from './actions/SortVoteList'

export const ContextualBlockActionsManager: React.FC<React.PropsWithChildren<unknown>> = () => {
  const state = useEditorState()
  const editorView = useEditorView()
  const [ps, setPs] = useState<ContextualBlockActionsPluginState | null>(null)
  const activeActionsMap = Array.from(registeredActions.values()).filter(({ active }) => {
    if (!ps) return false
    const { caretContext, hoveredContext } = ps
    return (caretContext && active(caretContext)) || (hoveredContext && active(hoveredContext))
  })

  useEffect(() => {
    registerSortVoteList()
    return () => {
      registeredActions.clear()
    }
  }, [])

  useLayoutEffect(() => {
    const pluginState: ContextualBlockActionsPluginState = ContextualBlockActionsPluginKey.getState(state)
    if (isEqual(ps, pluginState)) return
    setPs(pluginState)
  }, [state, ps])

  return (
    <>
      {ps &&
        activeActionsMap.map((action) => {
          const portals = action.getPortals(editorView, ps)
          return portals.map((portal) => createPortal(portal.element, portal.container, portal.key))
        })}
    </>
  )
}
